import React, { useEffect, useState } from 'react'
import {
  CFormTextarea,
  CCard,
  CButton,
  CSpinner,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CCardBody,
  CFormInput,
  CFormLabel,
  CForm,
  CRow,
  CCol,
  CTable,
  CTableBody,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CTableDataCell,
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
} from '@coreui/react'
import Carder from '../../components/shared/Carder'
import { toastConfig } from '../../constants/other.config'
import toast from 'react-hot-toast'
import GetPatientAllergiesCRUD from '../../services/general/getPatientAllergies.api'
import CustomDatePickingFormat from '../../../src/components/shared/CustomDatePickingFormat'
import { CalendarIcon, Plus } from 'lucide-react'
import { useIndexedDB } from '../../context/IndexedContext'
const ProviderPatientAllergies = ({ patientID, loading, showPlusButton = true, setLoading, saveTreatsShell, allergiesList, setAllergiesList, noteStructureRef, patientDBData, setPatientDBData, noteCallType }) => {
  const getFormattedDateUsFormat = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    return `${mm}/${dd}/${yyyy}`
  }
  const [modalVisible, setModalVisible] = useState(false)
  const [allergyEditId, setAllergyEditId] = useState(null)
  const [waiter, setWaiter] = useState(false)
  const [allergy, setAllergy] = useState({
    allergen: '',
    severity: '',
    reaction: '',
    dateOfOnset: getFormattedDateUsFormat(),
    updated: '',
  })
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [editableAllergiesId, setEditableAllergiesId] = useState([])

  const getLoggedProviderId = () => {
    const provider = JSON.parse(localStorage.getItem('loggedUserProviderId'))
    return provider || null
  }

  const { getOfflineData, getProviderDetails, saveOfflineData, getOpenChartOfflineData, saveOpenChartOfflineData } = useIndexedDB()

  useEffect(() => {
    fetchAllergies()
  }, [patientID, patientDBData])

  const handleAllergyChange = (e) => {
    const { name, value } = e.target
    setAllergy((prevAllergy) => ({
      ...prevAllergy,
      [name]: value,
    }))
  }

  const fetchAllergies = async () => {
    try {
      let formattedData
      let withoutSorted

      formattedData = patientDBData?.patientAllergy || []
      if (formattedData) {
        withoutSorted = formattedData?.map((item) => {
          return {
            ...item,
            data: JSON.parse(item.data),
          }
        })
        formattedData = formattedData?.map((item) => {
          return {
            ...item,
            data: JSON.parse(item.data),
          }
        })
      }
      // formattedData.sort((a, b) => new Date(b?.date) - new Date(a?.date));
      setAllergiesList(formattedData?.reverse())
      return withoutSorted
    } catch (error) {
      console.log(error)
      toast.error('Error fetching allergies', toastConfig)
    }
  }

  const addAllergyinLocal = async (allergy) => {
    const data = noteCallType === 'OpenChart' ? await getOpenChartOfflineData() : await getOfflineData()
    const loggedUser = await getProviderDetails()
    const loggedUserID = loggedUser?.ID
    const userData = { ...(data[loggedUserID] || {}) }
    const patientData = { ...(userData[patientID] || {}) }
    const existingAllergies = patientData.patientAllergy || []
    const newlyAddedData = patientData.newlyAddedData || []
    const newlyAddedAllergy = patientData?.newlyAddedData?.patientAllergy || []

    const newAllergy = {
      data: JSON.stringify(allergy),
      patientID: patientID,
    }
    const updatedPatientData = {
      ...patientData,
      patientAllergy: [...existingAllergies, newAllergy],
      newlyAddedData: { ...newlyAddedData, patientAllergy: [...newlyAddedAllergy, newAllergy] },
    }

    const updatedUserData = {
      ...userData,
      [patientID]: updatedPatientData,
    }

    const updatedData = {
      ...data,
      [loggedUserID]: updatedUserData,
    }

    noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(updatedData) : await saveOfflineData(updatedData)

    setPatientDBData(updatedPatientData)
    await fetchAllergies()
  }

  // const fetchAllergies = async () => {
  //   try {
  //     let formattedData
  //     let withoutSorted
  //     formattedData = await GetPatientAllergiesCRUD('GET', patientID)
  //     formattedData = JSON.parse(formattedData.d)
  //     formattedData = formattedData?.Data || []
  //     if (formattedData) {
  //       withoutSorted = formattedData?.map((item) => {
  //         return {
  //           ...item,
  //           data: JSON.parse(item.data),
  //         }
  //       })
  //       formattedData = formattedData?.map((item) => {
  //         return {
  //           ...item,
  //           data: JSON.parse(item.data),
  //         }
  //       })
  //     }
  //     // formattedData.sort((a, b) => new Date(b?.date) - new Date(a?.date));
  //     setAllergiesList(formattedData?.reverse())
  //     return withoutSorted
  //   } catch (error) {
  //     console.log(error)
  //     toast.error('Error fetching allergies', toastConfig)
  //   }
  // }

  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    const hh = String(today.getHours()).padStart(2, '0')
    const min = String(today.getMinutes()).padStart(2, '0')
    return `${mm}.${dd}.${yyyy} ${hh}:${min}`
  }

  // const handleAddAllergy = async () => {
  //   // if (!allergy.allergen || !allergy.dateOfOnset || !allergy.reaction || !allergy.reaction) {
  //   //     toast.error("Please fill the fields with information", toastConfig)
  //   //     return
  //   // }

  //   setWaiter(true)
  //   try {
  //     if (allergyEditId !== null) {
  //       await GetPatientAllergiesCRUD('UPDATE', patientID.toString(), JSON.stringify(allergy), allergyEditId.toString())
  //       setModalVisible(false)
  //       setAllergyEditId(null)
  //       setAllergy({
  //         allergen: '',
  //         severity: '',
  //         reaction: '',
  //         dateOfOnset: '',
  //         updated: '',
  //       })
  //       await fetchAllergies()
  //       toast.success('Successfully Updated', toastConfig)
  //     } else {
  //       await GetPatientAllergiesCRUD('INSERT', patientID.toString(), JSON.stringify(allergy), '', getFormattedDate())
  //       setModalVisible(false)
  //       setAllergy({
  //         allergen: '',
  //         severity: '',
  //         reaction: '',
  //         dateOfOnset: '',
  //         updated: '',
  //       })
  //       const allAllergies = await fetchAllergies()
  //       if (allAllergies.length > 0) {
  //         const lastAllergyId = allAllergies[allAllergies.length - 1]?.id

  //         if (lastAllergyId) {
  //           const existingIds = noteStructureRef.current?.metadata?.allergiesIds || []

  //           const updatedIds = [...new Set([...existingIds, lastAllergyId])]

  //           noteStructureRef.current = {
  //             ...noteStructureRef.current,
  //             metadata: {
  //               ...noteStructureRef.current?.metadata,
  //               allergiesIds: updatedIds,
  //             },
  //           }

  //           setEditableAllergiesId(updatedIds)
  //         }
  //       }
  //       toast.success('Successfully Added', toastConfig)
  //       await saveTreatsShell(false)
  //     }
  //   } catch (error) {
  //     console.log(error)
  //   } finally {
  //     setWaiter(false)
  //   }
  // }

  const handleAddAllergy = async () => {
    // if (!allergy.allergen || !allergy.dateOfOnset || !allergy.reaction || !allergy.reaction) {
    //     toast.error("Please fill the fields with information", toastConfig)
    //     return
    // }

    setWaiter(true)
    try {
      await addAllergyinLocal(allergy)
      setModalVisible(false)
      setAllergy({
        allergen: '',
        severity: '',
        reaction: '',
        dateOfOnset: '',
        updated: '',
      })
      toast.success('Successfully Added', toastConfig)
      await saveTreatsShell(false)
    } catch (error) {
      console.log(error)
    } finally {
      setWaiter(false)
    }
  }

  const handleEditAllergies = (allergy) => {
    setModalVisible(true)
    setAllergy(allergy.data)
    setAllergyEditId(allergy.id)
  }

  const handleDeleteAllergies = async (id) => {
    await GetPatientAllergiesCRUD('DELETE', patientID.toString(), '', deleteVisibleId?.toString())
    await fetchAllergies()
    setDeleteVisibleId(null)
  }

  useEffect(() => {
    const allAllergiesIdsEditable = noteStructureRef.current?.metadata?.allergiesIds || []
    setEditableAllergiesId(allAllergiesIdsEditable || [])
  }, [])

  return (
    <>
      {/* <CButton style={{ marginTop: "10px" }} onClick={() => setModalVisible(true)} variant="outline" color="primary">
                + Add Allergy
            </CButton> */}

      {/* delete modal */}
      <CModal visible={deleteVisibleId}>
        <CModalHeader>
          <CModalTitle>Warning</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
        </CModalBody>
        <hr className="p-0 m-0" />
        <CModalFooter className="p-3 m-0">
          <CButton
            onClick={() => {
              setDeleteVisibleId(null)
            }}
            className="text-white"
            color="secondary"
          >
            Close
          </CButton>
          <CButton onClick={handleDeleteAllergies} className="text-white" color="danger">
            Delete
          </CButton>
        </CModalFooter>
      </CModal>

      <CAccordion activeItemKey={2}>
        <CAccordionItem itemKey={1}>
          <CAccordionHeader>
            <div className="d-flex gap-2 align-items-center">
              <p style={{ fontSize: '1rem' }} className="m-0 p-0 font-weight-medium text-capitalize">
                Allergies
              </p>
              {showPlusButton && (
                <CFormLabel
                  onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    setModalVisible(true)
                  }}
                  className="d-flex p-0 m-0 flex-column align-items-center justify-content-center mt-1 shadow "
                  style={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '20px',
                    background: '#4363F2',
                    cursor: 'pointer',
                  }}
                >
                  {<Plus className="text-white" strokeWidth={2} size={15} />}
                </CFormLabel>
              )}
            </div>
          </CAccordionHeader>
          <CAccordionBody>
            <div className="">
              {allergiesList.length > 0 &&
                // allergiesList.filter(item => noteStructureRef?.current?.metadata?.allergiesIds?.includes(item.id)).map((item, idx) => {
                allergiesList?.map((item, idx) => {
                  return (
                    <div key={idx} className="mb-2 border rounded">
                      <span style={{ borderBottom: '1px solid #e9e9e9' }} className="d-flex gap-2 p-2 text-small align-items-center juween">
                        <CalendarIcon strokeWidth={1} size={15} />
                        <p className="m-0" style={{ fontWeight: '' }}>
                          {item.data?.dateOfOnset}
                        </p>
                      </span>
                      <div key={idx} className="p-2">
                        <p className="m-0" style={{ fontWeight: '600' }}>
                          Allergy: {item.data?.allergen}
                        </p>
                        <p className="m-0" style={{ fontWeight: '600' }}>
                          Severity: {item.data?.severity}
                        </p>
                        <p className="text-warning m-0">Reaction: {item.data?.reaction}</p>
                      </div>
                    </div>
                  )
                })}
              {allergiesList.length === 0 && (
                <p className="text-start text-muted">
                  Patient Has No Allergies
                </p>
              )}
            </div>
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>
      {/* 
      <CModal size="lg" scrollable backdrop={'static'} visible={modalVisible} onClose={() => setModalVisible(false)}>
        <CModalHeader onClose={() => setModalVisible(false)}>
          <CModalTitle>Add Patient Allergy</CModalTitle>
        </CModalHeader>
        <CModalBody style={{ height: '500px' }}>
          <CForm>
            <CRow className="mb-3">
              <CCol xs="6">
                <CFormLabel>Allergen</CFormLabel>
                <CFormInput type="text" name="allergen" value={allergy.allergen} onChange={handleAllergyChange} />
              </CCol>
              <CCol xs="6">
                <CFormLabel>Severity</CFormLabel>
                <CFormInput type="text" name="severity" value={allergy.severity} onChange={handleAllergyChange} />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol xs="6">
                <CFormLabel>Reaction</CFormLabel>
                <CFormInput type="text" name="reaction" value={allergy.reaction} onChange={handleAllergyChange} />
              </CCol>
              <CCol xs="6" className="d-flex flex-column">
                <CFormLabel>Date of Onset</CFormLabel>
                <CFormInput
                                    type="date"
                                    name="dateOfOnset"
                                    value={allergy.dateOfOnset}
                                    onChange={handleAllergyChange}
                                />

                <CustomDatePickingFormat
                  className=""
                  value={allergy.dateOfOnset}
                  onChange={(e) => {
                    setAllergy((p) => ({
                      ...p,
                      dateOfOnset: e,
                    }))
                  }}
                  format="mm-dd-yyyy"
                />
              </CCol>
            </CRow>
          </CForm>
        </CModalBody>
        <CModalFooter>
          <CButton color="primary" variant="outline" onClick={handleAddAllergy}>
            {waiter ? (
              <>
                <CSpinner component="span" size="sm" variant="grow" aria-hidden="true" />
                Loading...
              </>
            ) : (
              <>{allergyEditId !== null ? 'Update Allergy' : 'Add Allergy'}</>
            )}
          </CButton>
          <CButton variant="outline" color="secondary" onClick={() => setModalVisible(false)}>
            Cancel
          </CButton>
        </CModalFooter>
      </CModal> */}

      <CModal className="" size="lg" scrollable backdrop="static" visible={modalVisible} onClose={() => setModalVisible(false)}>
        <CModalHeader
          style={{
            backgroundColor: '#282828',
            borderBottom: '1px solid gray',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            position: 'relative', // allows absolute positioning
          }}
        >
          <CModalTitle
            style={{
              color: 'white',
              textAlign: 'center',
              width: '100%',
            }}
          >
            Add Patient Allergy
          </CModalTitle>

          {/* Custom close button */}
        </CModalHeader>

        <CModalBody
          style={{
            height: '400px',
            backgroundColor: '#282828',
            color: 'white',
          }}
        >
          <CForm>
            <CRow className="mb-3">
              <CCol xs="6">
                <CFormLabel style={{ color: 'white' }}>Allergen</CFormLabel>
                <CFormInput
                  type="text"
                  name="allergen"
                  value={allergy.allergen}
                  onChange={handleAllergyChange}
                  style={{
                    backgroundColor: '#191919',
                    border: '1px solid gray',
                    color: 'white',
                  }}
                />
              </CCol>
              <CCol xs="6">
                <CFormLabel style={{ color: 'white' }}>Severity</CFormLabel>
                <CFormInput
                  type="text"
                  name="severity"
                  value={allergy.severity}
                  onChange={handleAllergyChange}
                  style={{
                    backgroundColor: '#191919',
                    border: '1px solid gray',
                    color: 'white',
                  }}
                />
              </CCol>
            </CRow>

            <CRow className="mb-3">
              <CCol xs="6">
                <CFormLabel style={{ color: 'white' }}>Reaction</CFormLabel>
                <CFormInput
                  type="text"
                  name="reaction"
                  value={allergy.reaction}
                  onChange={handleAllergyChange}
                  style={{
                    backgroundColor: '#191919',
                    border: '1px solid gray',
                    color: 'white',
                  }}
                />
              </CCol>

              <CCol xs="6" className="d-flex flex-column">
                <CFormLabel style={{ color: 'white' }}>Date of Onset</CFormLabel>
                <CustomDatePickingFormat
                  value={allergy.dateOfOnset}
                  onChange={(e) =>
                    setAllergy((p) => ({
                      ...p,
                      dateOfOnset: e,
                    }))
                  }
                  format="mm-dd-yyyy"
                  className="text-white"
                  style={{
                    backgroundColor: '#191919',
                    border: '1px solid gray',
                    color: 'white',
                  }}
                />
              </CCol>
            </CRow>
          </CForm>
        </CModalBody>

        <CModalFooter
          style={{
            backgroundColor: '#282828',
            borderTop: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
          }}
          className="pt-2"
        >
          <CButton
            onClick={handleAddAllergy}
            style={{
              backgroundColor: '#4363F2',
              border: 'none',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
          >
            {waiter ? (
              <>
                <CSpinner component="span" size="sm" variant="grow" aria-hidden="true" />
                Loading...
              </>
            ) : (
              <>{allergyEditId !== null ? 'Update Allergy' : 'Add Allergy'}</>
            )}
          </CButton>

          <CButton
            onClick={() => setModalVisible(false)}
            style={{
              backgroundColor: '#333',
              border: '1px solid gray',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
          >
            Cancel
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ProviderPatientAllergies
